export enum WeekDays {
  'monday' = 'monday',
  'tuesday' = 'tuesday',
  'wednesday' = 'wednesday',
  'thursday' = 'thursday',
  'friday' = 'friday',
}

export const WEEK_DAY_MAP = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
};

export const CUSTOM_DIALOG_HEIGHT = {
  dialogOneSm: '300px',
  dialogOneMd: '400px',
};
